import { computed, h, defineComponent } from 'vue';
import { hasPermission, Permissions } from '@/ui/auth/auth';
import NotesIcon from '@/_legacy/components/Icons/NotesIcon.vue';
import CameraIcon from '@/_legacy/components/Icons/CameraIcon.vue';
import { Icon } from '@/ui/components/icon/Icon';

interface QuestionOptionsProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  item: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entities: any;
}

export const QuestionOptions = defineComponent<QuestionOptionsProps>({
  name: 'QuestionOptions',
  props: ['item', 'entities'],
  setup(props, context) {
    const showOptions = computed(() => props.item.notes_allowed || props.item.photos_allowed || props.item.issues_allowed);

    const isIssuesAllowed = computed(() => props.item.issues_allowed && hasPermission(Permissions.CREATE_ISSUE));

    const notesIconFill = computed(() => props.item.notes ? 'var(--primary)' : 'var(--gray-60)');

    const photosIconFill = computed(() => props.item.photos && props.item.photos.length
      ? 'var(--primary)' : 'var(--gray-60)');

    const raiseIssueButtonClasses = computed(() => {
      const isIssueExistsForInspection = props.entities.inspection.issues
        && Object.keys(props.entities.inspection.issues).find(uuid => uuid === props.item.uuid);

      return {
        'text-60': !isIssueExistsForInspection,
        'text-primary': isIssueExistsForInspection,
      };
    });

    const showNotesModal = () => context.emit('showNotesModal', props.item.uuid);
    const showPhotosModal = () => context.emit('showPhotosModal', props.item.uuid);
    const showIssueModal = () => context.emit('showIssueModal', props.item.uuid);

    return function render() {
      return showOptions.value
        ? h('div', { class: 'flex mt-3' }, [
          props.item.notes_allowed
            ? h('button', {
              attrs: {
                type: 'button'
              },
              on: {
                click: showNotesModal,
              },
              class: 'w-16',
            }, [h(NotesIcon, { props: { fill: notesIconFill.value } })])
            : null,
          props.item.photos_allowed
            ? h('button', {
              attrs: {
                type: 'button'
              },
              on: {
                click: showPhotosModal,
              },
              class: 'w-16',
            }, [h(CameraIcon, { props: { fill: photosIconFill.value } })])
            : null,
          isIssuesAllowed.value
            ? h('button', {
              attrs: {
                type: 'button'
              },
              on: {
                click: showIssueModal,
              },
            }, [
              h(Icon, {
                class: [raiseIssueButtonClasses.value, 'h-6'],
                props: {
                  iconPack: 'far',
                  icon: 'bullhorn',
                  size: '2x'
                },
              })
            ])
            : null
        ]) : null;
    };
  },
});
